'use strict';

/* globals $ */

var _ = require('lodash');

var FalkorAdapter = {

    request: function(config) {
        return $.ajax({
            url: this.getRequestURL(config),
            cache: true,
            crossDomain: true,
            dataType: 'json'
        });
    },

    getRequestURL: function(config) {
        var url = _.template(
            '<%= host %>' +
            '/feeds/<%= feedId %>/posts' +
            '/page/<%= page %>')({
                host: config.falkorUrl,
                feedId: config.feedId,
                page: config.page
        });
        if (config.query_parameter) {
            return url.concat('/query_parameter/', encodeURI(config.query_parameter))
        }
        return url;
    },

    handleReceivedPosts: function(data, postStore) {
        if (postStore.tag) {
            this.addTag(data.items, postStore.tag);
            postStore._isRecommended = true;
        }

        postStore._hasNextPage = this.hasNextPage(data);
        return data.items;
    },

    addTag: function(posts, tag) {
        for (var i = 0; i < posts.length; i++) {
            if (posts[i].content.url)
                posts[i].content.url += tag;
            else
                posts[i].content.tag = tag;
        }
    },

    hasNextPage: function(data) {
        if (data.nextPage)
            return true;
        return false;
    }
};

module.exports = FalkorAdapter;
